import { StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import { COLOR } from 'utils/colors';

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
    },
    rightContainer: {
        flexDirection: 'row-reverse',
    },
    textContainer: {
        justifyContent: 'center',
    },
    background: {
        backgroundColor: COLOR.LIGHT_TEAL,
    },
    leftTextContainer: {
        borderBottomLeftRadius: 2,
        borderTopLeftRadius: 2,
        paddingLeft: 6,
    },
    rightTextContainer: {
        borderBottomRightRadius: 2,
        borderTopRightRadius: 2,
        paddingRight: 6,
    },
    textAlignRight: {
        textAlign: 'right',
    },
    text: {
        color: COLOR.background,
        fontWeight: 'bold',
    },
});

export default styles;
